import moment from 'moment';

const asLocalMoment = value => moment.utc(value).local();

export const formatVersionDate = value => asLocalMoment(value).format('MMM D, YYYY [at] h:mmA');

export const formatVersionDateLong = value => asLocalMoment(value).format('LLLL');

export const formatRelative = value => asLocalMoment(value).fromNow();
